<template>
  <div>
    <a-modal
      :title="'睡眠报告'"
      :visible="tan_gzList_moon_show"
      :maskClosable="false"
      @cancel="tan_gzList_moon_show = false"
      :dialog-style="{ 'min-width': '926px', 'max-width': '926px' }"
      :footer="null"
      id="old"
    >
      <div class="needGZ_TanWrap" v-if="tan_gzList_moon_show">
        <div class="needGZ_Tan" style="width: 926px;height: 891px;">
          <div class="needGZ_Top">
            <div class="time">最近30天</div>
            <div class="time2">&nbsp;/&nbsp;</div>
            <div class="time2" v-if="tan_gzList_moon_type == 1">需要关注的老人</div>
            <div class="time2" v-if="tan_gzList_moon_type == 2">状态优秀的老人</div>
            <div class="numRed" v-if="tan_gzList_moon_type == 1 && home_moon_follow_data">{{ home_moon_follow_data.totleCount }}位</div>
            <div class="numGreen" v-if="tan_gzList_moon_type == 2 && home_moon_foGood_data">{{ home_moon_foGood_data.totleCount }}位</div>
            <div class="chazi" @click="tan_gzList_moon_show = false">X</div>
          </div>
          
          <div class="needGZ_Cont">
            <!-- 需关注老人列表 -->
            <div v-if="tan_gzList_moon_type == 1 && tan_gzList_moon_data">
              <div class="topListWrap" v-if="home_moon_follow_data">
                <div 
                  :class="['topList',item.isSelect ? 'topListSel' : '']" 
                  :key="index" v-for="(item,index) in home_moon_follow_data.digitalTwinFollowCountList"
                  @click="clc_topList(index,item.index)"
                >
                  <div class="name">{{item.content}}</div>
                  <div class="num">{{ item.count }}位</div>
                </div>
              </div>


              <div class="oRightWrap" style="margin-left: 0;">
                <div class="oRightList" :key="index2" v-for="(item2,index2) in tan_gzList_moon_data.records">
                  <div class="o_topBox">
                    <img class="peoIconImg" src="../../../assets/home_icon_avatar_h@2x.png" alt="">
                    <div class="oName">{{item2.buAndFlName}}</div>
                  </div>
                  <div class="flex mt10">
                    <div class="varSta">
                      <img class="tanhaoIcon" src="../../../assets/report_icon_notice_d@2x.png" alt="">
                      <div>{{item2.contentList[0]}}</div>
                    </div>
                    <div class="exceIcon" v-if="item2.contentList.length > 2">
                      <div class="threePoint">...</div>
                    </div>
                  </div>
                  <div class="flex mt10" v-if="item2.contentList[1]">
                    <div class="varSta">
                      <img class="tanhaoIcon" src="../../../assets/report_icon_notice_d@2x.png" alt="">
                      <div>{{item2.contentList[1]}}</div>
                    </div>
                  </div>
                  <div class="btnSee" @click="open_tan_needGz_portrait(item2)">查看</div>
                </div>
              </div>
            </div>

            <!-- 优秀老人列表 -->
            <div v-if="tan_gzList_moon_type == 2 && tan_gzList_moon_data">
              <div class="topListWrap" v-if="home_moon_foGood_data">
                <div 
                  :class="['topList',item.isSelect ? 'topListSel' : '']" 
                  :key="index" v-for="(item,index) in home_moon_foGood_data.digitalTwinFollowCountList"
                  @click="clc_topList(index,item.index)"
                >
                  <div class="name">{{item.content}}</div>
                  <div class="num">{{ item.count }}位</div>
                </div>
              </div>

              <div class="oRightWrap" style="margin-left: 0;">
                <div class="oRightList" :key="index2" v-for="(item2,index2) in tan_gzList_moon_data.records">
                  <div class="o_topBox">
                    <img class="peoIconImg" src="../../../assets/home_icon_avatar_h@2x.png" alt="">
                    <div class="oName">{{item2.buAndFlName}}</div>
                  </div>
                  <div class="flex mt10">
                    <div class="varSta varSta2">
                      <div>{{item2.contentList[0]}}</div>
                    </div>
                    <div class="exceIcon" v-if="item2.contentList.length > 2">
                      <div class="threePoint">...</div>
                    </div>
                  </div>
                  <div class="flex mt10" v-if="item2.contentList[1]">
                    <div class="varSta varSta2">
                      <div>{{ item2.contentList[1] }}</div>
                    </div>
                  </div>
                  <div class="btnSee" @click="open_tan_needGz_portrait(item2)">查看</div>
                </div>
              </div>
            </div>
            

            <div class="mt30" v-if="tan_gzList_moon_data">
              <a-pagination
                v-model="tan_gzList_moon_pageNum"
                @change="tan_gzList_moon_pageChange"
                :total="tan_gzList_moon_data.total"
                :pageSize="tan_gzList_moon_pageSize"
                :hideOnSinglePage="true"
                show-less-items
                style="text-align: center;"
              />
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    
    <!-- 弹窗_关注老人单人详情 -->
    <tan_needGz_sin ref="tan_needGz_sin"></tan_needGz_sin>

    <!-- 弹窗_数字画像 -->
    <tan_needGz_portrait ref="tan_needGz_portrait"></tan_needGz_portrait>
  </div>
</template>

<script>
import portFn from '../../../utils/PortraitFunction.js';
import dataJson from './bbb.json'
import tan_needGz_sin from './tan_needGz_sin.vue';      //弹窗_关注老人单人详情
import tan_needGz_portrait from './tan_needGz_portrait.vue';      //弹窗_数字画像
export default {
  components: { tan_needGz_sin , tan_needGz_portrait},
  filters: {
    dataChange(val){
      let newVal = val.slice(5,7) + '月' + val.slice(8,10) + '日'
      return newVal;
    },
  },
  props: {
    
  },
  watch: {
    
  },
  data() {
    return {
      home_moon_follow_data: null,    //首页_30天需关注数据
      home_moon_foGood_data: null,    //首页_30天状态优秀数据
      // 弹窗关注老人列表三十天部分
      tan_gzList_moon_show: false,
      tan_gzList_moon_type: 1,         //需关注1 状态优秀2
      tan_gzList_moon_data: null,      //弹窗_列表数据（需关注、状态优秀共用）
      tan_gzList_moon_pageNum: 1,          
      tan_gzList_moon_pageSize: 20,          
      tan_gzList_moon_sortField: '',          //排序字段
      tan_gzList_moon_sortOrder: 'ascend',    //顺序规则 正序-ascend，倒序-descend
      tan_flagList_typeArr: [],       // 弹窗_报警列表_类别数组（早睡早起、睡得超安稳等）_需关注
      tan_flagList_typeAr2r: [],       // 弹窗_报警列表_类别数组（早睡早起、睡得超安稳等）_状态优秀
    };
  },
  created() {},
  mounted() {
    
    
  },
  methods: {
    
    // 外界调用这个组件
    openComponent_tan_needGz_list_moon(data){
      console.log(data)
      console.log('调用了需关注列表月_____')
      // 初始化分页
      
      this.tan_gzList_moon_pageNum = 1,          
      this.tan_gzList_moon_pageSize = 20,          
      
      this.tan_gzList_moon_type = data.type;

      this.tan_gzList_moon_show = true;
      if(this.tan_gzList_moon_type == 1){
        this.getHomeDigitalTwinFollowList()         //首页_查看最近30天需要关注老人
      }else if(this.tan_gzList_moon_type == 2){
        this.getDigitalTwinFollowGoodTableList()    //首页_查看最近30天状态优秀的老人
      }
      
    },
    
    
    // 首页_查看最近30天需要关注老人
    getHomeDigitalTwinFollowList(){
      let obj = {}
      this.$get(
        'api/v4/home/getHomeDigitalTwinFollowList',
        obj,
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              console.log(res.data)
              this.home_moon_follow_data = res.data;

              // for(let i = 0;i < 2;i++){
                // this.home_moon_follow_data.digitalTwinFollowCountList.push(this.home_moon_follow_data.digitalTwinFollowCountList[i])
              // }
              // for(let i = 0;i < 18;i++){
              //   this.home_moon_follow_data.needFollowPageListVoList.push(this.home_moon_follow_data.needFollowPageListVoList[i])
              // }
             

              // 二维数组变一维数组start
              let voList = res.data.needFollowPageListVoList
              console.log(voList)
              let len = voList.length;
              let n = 8;
              let num = len % 8 === 0 ? len / 8 : Math.floor((len / 8) + 1)  //得出多少份
              let newList = []
              for (let i = 0; i < num; i++) {
                // slice() 方法返回一个从开始到结束（不包括结束）的数组。且原始数组不会被修改。
                const newArr = voList.slice(i * n, i * n + n) //得到每份的数据
                newList.push(newArr) //往res数组里加数据
              }
              console.log(newList, '二维数组')
              this.home_moon_follow_data.newList = newList
              // 二维数组变一维数组end


              // 会用于弹窗列表内
              this.tan_flagList_typeArr = []    //弹窗_报警列表_类别数组（早睡早起，睡得超安稳等）
              for(let i = 0;i < this.home_moon_follow_data.digitalTwinFollowCountList.length;i++){
                this.home_moon_follow_data.digitalTwinFollowCountList[i].isSelect = true;
                this.tan_flagList_typeArr.push(this.home_moon_follow_data.digitalTwinFollowCountList[i].index)
              }

              
              this.getDigitalTwinFollowPageList()     //弹窗_需关注列表
              this.$forceUpdate()
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 首页_查看最近30天状态优秀的老人
    getDigitalTwinFollowGoodTableList(){
      let obj = {}
      this.$get(
        'api/v4/home/getDigitalTwinFollowGoodTableList',
        obj,
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.home_moon_foGood_data = res.data;

              // 二维数组变一维数组start
              let voList = res.data.needFollowPageListVoList
              console.log(voList)
              let len = voList.length;
              let n = 8;
              let num = len % 8 === 0 ? len / 8 : Math.floor((len / 8) + 1)  //得出多少份
              let newList = []
              for (let i = 0; i < num; i++) {
                // slice() 方法返回一个从开始到结束（不包括结束）的数组。且原始数组不会被修改。
                const newArr = voList.slice(i * n, i * n + n) //得到每份的数据
                newList.push(newArr) //往res数组里加数据
              }
              console.log(newList, '二维数组')
              this.home_moon_foGood_data.newList = newList
              // 二维数组变一维数组end

              
              this.tan_flagList_typeArr2 = []    //弹窗_报警列表_类别数组（早睡早起，睡得超安稳等）
              for(let i = 0;i < this.home_moon_foGood_data.digitalTwinFollowCountList.length;i++){
                this.home_moon_foGood_data.digitalTwinFollowCountList[i].isSelect = true;
                this.tan_flagList_typeArr2.push(this.home_moon_foGood_data.digitalTwinFollowCountList[i].index)
              }
              this.getDigitalTwinFollowGoodPageList()     //弹窗_状态优秀列表
              this.$forceUpdate()
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 弹窗_需关注列表
    getDigitalTwinFollowPageList(){
      console.log(this.tan_flagList_typeArr)
      let obj = {
        flagList: this.tan_flagList_typeArr.toString(),
        pageNum: this.tan_gzList_moon_pageNum,
        pageSize: this.tan_gzList_moon_pageSize,
        selectDateType: 30,    //取值:1, 7该参数不传默认为: 1
        sortField: this.tan_gzList_moon_sortField,
        sortOrder: this.tan_gzList_moon_sortField,     //顺序规则 正序-ascend，倒序-descend	
      }
      this.$get(
        'api/v4/home/getDigitalTwinFollowPageList',
        obj,
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              console.log(res.data)
              this.tan_gzList_moon_data = res.data;

              
              this.$forceUpdate()
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 弹窗_状态优秀列表
    getDigitalTwinFollowGoodPageList(){
      let obj = {
        flagList: this.tan_flagList_typeArr2.toString(),
        pageNum: this.tan_gzList_moon_pageNum,
        pageSize: this.tan_gzList_moon_pageSize,
        selectDateType: 30,    //取值:1, 7该参数不传默认为: 1
        sortField: this.tan_gzList_moon_sortField,
        sortOrder: this.tan_gzList_moon_sortField,     //顺序规则 正序-ascend，倒序-descend	
      }
      this.$get(
        'api/v4/home/getDigitalTwinFollowGoodPageList',
        obj,
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              console.log(res.data)
              this.tan_gzList_moon_data = res.data;
              
              // for(let i = 0;i < 18;i++){
              //   this.tan_gzList_moon_data.records.push(this.tan_gzList_moon_data.records[i])
              // }
              
              this.$forceUpdate()
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 弹窗_需关注列表_点击某个类别（早睡早起，睡得超安稳等）
    clc_topList(index,type){
      this.tan_gzList_moon_pageNum = 1;
      this.tan_gzList_moon_pageSize = 20;
      this.tan_bjList_sortField = ''
      this.tan_bjList_sortOrder = 'ascend'

      if(this.tan_gzList_moon_type == 1){         //需关注
        console.log(this.tan_flagList_typeArr)
        this.home_moon_follow_data.digitalTwinFollowCountList[index].isSelect = !this.home_moon_follow_data.digitalTwinFollowCountList[index].isSelect
        
        let isIndexOf = this.tan_flagList_typeArr.indexOf(type)
        if(isIndexOf != -1){
          this.tan_flagList_typeArr.splice(isIndexOf,1)
        }else {
          this.tan_flagList_typeArr.push(type)
        }
        this.getDigitalTwinFollowPageList()
      }else if(this.tan_gzList_moon_type == 2){   //状态优秀
        console.log(this.tan_flagList_typeArr2)
        this.home_moon_foGood_data.digitalTwinFollowCountList[index].isSelect = !this.home_moon_foGood_data.digitalTwinFollowCountList[index].isSelect
        
        let isIndexOf = this.tan_flagList_typeArr2.indexOf(type)
        if(isIndexOf != -1){
          this.tan_flagList_typeArr2.splice(isIndexOf,1)
        }else {
          this.tan_flagList_typeArr2.push(type)
        }
        this.getDigitalTwinFollowGoodPageList()
      }
      
     
    },
    // 弹窗_关注老人列表_分页
    tan_gzList_moon_pageChange(e) {
      console.log(e);
      this.tan_gzList_pageNum = e;
      if(this.tan_gzList_moon_type == 1){
        this.getDigitalTwinFollowPageList()
      }else if(this.tan_gzList_moon_type == 2){
        this.getDigitalTwinFollowGoodPageList()
      }
    },
    
    // 点击关注老人中的某一个，出需关注单人详情
    open_tan_needGz_portrait(data){
      this.$refs.tan_needGz_portrait.openComponent_tan_needGz_portrait(data)
    },
    





    
    
  },
};
</script>
<style lang="scss" scoped>
@import '../../../assets/css/comHome.scss';

.oRightWrap{
  width: 874px;
  height: auto;
  // margin-top: -8px;
  display: flex;
  align-items: center;
  // justify-content: center;
  flex-wrap: wrap;
  margin-left: auto;
  position: relative;
  
  // .oRightList:nth-of-type(1),
  // .oRightList:nth-of-type(5),
  // .oRightList:nth-of-type(9),
  // .oRightList:nth-of-type(14){
  //   margin-left: 0;
  // }
  .oRightList:nth-of-type(4n+1){
    margin-left: 0;
  }
  .oRightList{
    width: 211px;
    height: 123px;
    background: #F7F8FA;
    border-radius: 4px;
    padding: 15px;
    box-sizing: border-box;
    margin-left: 10px;
    position: relative;
    margin-top: 10px;
    .o_topBox{
      display: flex;
      align-items: center;
      .peoIconImg{
        width: 20px;
        height: 20px;
        display: block;
      }
      .oName{
        width: 154px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5E6779;
        margin-left: 5px;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .varSta{
      padding: 2px 10px 2px 5px;
      background: #FFE0E4;
      border-radius: 19px;
      border: 1px solid #FFB8C3;
      backdrop-filter: blur(8px);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5E6779;

      display: flex;
      align-items: center;
      .tanhaoIcon{
        width: 14px;
        height: 14px;
        display: block;
        margin-right: 3px;
      }
    }
    .varSta2{
      padding: 2px 10px 2px 10px;
      background: #E0F0FF;
      border: 1px solid #B7DCFE;
    }
    .exceIcon{
      width: 43px;
      height: 24px;
      background: #EBECEF;
      border-radius: 12px 12px 12px 2px;
      margin-left: auto;
      .threePoint{
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #5E6779;
        margin-left: 5px;
        margin-top: 2px;
      }
    }
    .btnSee{
      width: 58px;
      height: 30px;
      line-height: 30px;
      background: #DFECFA;
      border-radius: 16px 0px 4px 0px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1890FF;
      text-align: center;
      cursor: pointer;

      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
  .backIcon{
    width: 57px;
    height: 57px;
    display: block;
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .backIcon_left{
    left: -15px;
    z-index: 999;
  }
  .backIcon_right{
    right: -15px;
    z-index: 999;
  }
}

</style>
